import axios from "axios";
import api from "../api";

function create(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .post(api.messageBoard, params)
      .then(async (response) => {
        resolve({
          messageBoard: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function read(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${api.messageBoard}`, params)
      .then((response) => {
        resolve({
          messageBoards: response?.data?.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function update(body = {}) {
  return new Promise((resolve, reject) => {
    axios
      .put(`${api.messageBoard}/${body.id}`, body)
      .then(async (response) => {
        resolve({
          messageBoard: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function destroy(id) {
  return new Promise(async (resolve, reject) => {
    axios
      .delete(`${api.messageBoard}/${id}`)
      .then((response) => {
        resolve({
          messageBoard: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function get(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${api.messageBoard}/${id}`)
      .then((response) => {
        resolve({
          messageBoard: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getmessageBoardRules() {
  return new Promise((resolve, reject) => {
    axios
      .get(`${api.messageBoard_rules}`)
      .then((response) => {
        resolve({
          messageBoardRules: response.data.rules,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export default {
  read,
  create,
  update,
  destroy,
  get,
  getmessageBoardRules
};
